import { useTranslation } from "react-i18next";
import "../spf.scss";
import "./spf-document.scss";
import { useLayout } from "../../../layouts/layout";
import { Breadcrumb, Button, Col, Form, Image, Input, Row, Steps, Switch, Tooltip } from "antd";
import { _adr } from "../../../../address";
import { DeleteOutlined, EditOutlined, HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import UploadImages from "../../../auxiliary/uploadImages/upload";
import PrintDocument from "../../print/printDocument";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ExportDocument,
  base64ToFile,
  delay,
  fileToformData,
  getFieldDocument,
  mergeSignatureWithBackground,
  urltoFile,
  validateInput,
} from "../../../../tools/tools";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import Loading from "../../../auxiliary/loader/loading";
import { useLocation, useNavigate } from "react-router-dom";
import SPFShopLayout from "../spf-shop-layout";
import { DocType, Roles } from "../../../../tools/services";
import ResizeImage from "../../../auxiliary/resizeImg/resizeImage";
import ReactSignatureCanvas from "react-signature-canvas";

import { isMobile, isTablet } from "react-device-detect";
const SPFDocument = () => {
  const { setLayout } = useLayout();
  const [t] = useTranslation("global");
  const formData = useSelector((state) => state);
  const nav = useNavigate();
  const location = useLocation();
  const [frmDocument] = Form.useForm();
  const [frmEmail] = Form.useForm();
  const { updateDocumentSPPurchase, updateDocumentSPPurchaseWithAddDoc } = useDealer();
  const { addDocument } = useAPIPublic();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });

  const [isEmail, setIsEmail] = useState(false);

  const [signature, setSignature] = useState(false);

  const [bgSingature, setBgSingature] = useState("");

  const [hasErrorSign, setHasErrorSign] = useState(false);

  const refBox = useRef("");

  useEffect(() => {
    setSignature(isMobile || isTablet ? _currentUser?.roles?.includes(Roles.Dealer_RegisterSim_Allow_Get_Signature_FromCustomer) : false);
    if (!(isMobile || isTablet ? _currentUser?.roles?.includes(Roles.Dealer_RegisterSim_Allow_Get_Signature_FromCustomer) : false)) {
      setLayout(
        <PrintDocument
          print={{
            ...(formData?.from?.spForeign || formData?.another?.spForeign),
            branchcode: formData?.another?._currentUser?.branchcode,
          }}
          lang={(formData?.from?.spForeign?.certtype || formData?.another?.spForeign?.certtype) === 1 ? "en" : "fa"}
        />,
      );
    }
  }, []);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      let validemail = await frmEmail.validateFields();
      if (isEmail) {
        if (!validemail) {
          setIsLoading(false);
          return false;
        }
      }

      let valid = await frmDocument.validateFields();
      if (valid) {
        // let responsne = await updateDocumentSPPurchaseWithAddDoc(
        //   await ExportDocument(valid.photo),
        //   DocType.SPDocument,
        //   location?.state?.sppurchaseid,
        // );
        // if (!responsne?.HasError) {
        //   nav(_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Final, { state: location?.state });
        // }
        let resDoc = await addDocument(await fileToformData(valid.photo), "SPDocument");
        if (resDoc) {
          let payload = {
            sppurchaseid: location?.state?.sppurchaseid,
            documentid: resDoc.Result,
            email: isEmail ? validemail?.email : undefined,
          };
          let responsne = await updateDocumentSPPurchase(payload);
          if (responsne && !responsne?.HasError) {
            nav(_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Final, { state: location?.state });
          }
        }
      }
    } catch (error) {
      setHasErrorSign(true);
    }
    setIsLoading(false);
  };
  const handleGetImage = async (value) => {
    frmDocument.setFieldValue("photo", value);
  };

  const handleGetCanvas = (img) => {
    setBgSingature(img);
  };

  useEffect(() => {
    const setChangeCanvas = () => {
      if (bgSingature) {
        let canvas = document.getElementById("canvasDoc");
        let parentElement = canvas.parentElement;
        canvas.width = parentElement.clientWidth;
        canvas.height = parentElement.clientHeight;
      }
    };
    setChangeCanvas();
    window.addEventListener("orientationchange", setChangeCanvas);
    return () => {
      window.removeEventListener("orientationchange", setChangeCanvas);
    };
  }, [bgSingature]);

  const clearHandler = () => {
    let canvas = document.getElementById("canvasDoc");
    let context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    frmDocument.setFieldValue("photo", null);
  };
  const writeSignatureHandler = async () => {
    const signatureCanvas = document.getElementById("canvasDoc");
    const imgData = await mergeSignatureWithBackground(bgSingature, signatureCanvas);
    frmDocument.setFieldValue("photo", await base64ToFile(imgData));
  };
  return (
    <>
      <SPFShopLayout>
        <div className="g-hold-title-of-page">
          <Breadcrumb
            className="breadcrumbs"
            items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardpurchase.global.title") }]}
          />
          <div className="title-page">
            <h3>{t("simcardpurchase.global.title")}</h3>
          </div>
        </div>
        <div className="g-layout-content">
          <Content className="g-layout-main sp-container">
            <div className="g-format-page">
              <div className="g-body-format-page">
                <div className="g-format-steps">
                  <div className="holder-step">
                    <Steps
                      size="small"
                      className="step-wizard"
                      current={5}
                      items={[
                        {
                          title: "بسته آغازین",
                        },
                        {
                          title: "احراز هویت",
                        },
                        {
                          title: "اطلاعات هویتی",
                        },
                        {
                          title: "پیش فاکتور",
                        },
                        {
                          title: "سند",
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="holder-document-page">
                  <div className="holder-document">
                    {signature ? (
                      <>
                        <div className="item-step" style={{ marginBottom: "0" }}>
                          <br />
                          <Form layout="vertical" form={frmEmail}>
                            <Row>
                              <Col xxl={8}>
                                <Form.Item label="">
                                  <Row gutter={30}>
                                    <Col>
                                      <label htmlFor="">مایل به ارسال سند بصورت ایمیل هستید؟</label>
                                    </Col>
                                    <Col>
                                      <Switch
                                        onChange={() => {
                                          setIsEmail((prev) => !prev);
                                        }}
                                        checked={isEmail}
                                        size="large"
                                        className="switcherOpration"
                                      />
                                    </Col>
                                  </Row>
                                </Form.Item>
                              </Col>
                            </Row>
                            {isEmail && (
                              <Row>
                                <Col xxl={5}>
                                  <Form.Item
                                    className="input-normal"
                                    name="email"
                                    label="پست الکترونیکی"
                                    rules={[
                                      validateInput({
                                        t: t,
                                        validate: true,
                                        type: "email",
                                      }),
                                    ]}
                                  >
                                    <Input dir="ltr" inputMode="email" />
                                  </Form.Item>
                                </Col>
                              </Row>
                            )}
                          </Form>
                        </div>
                        <Row>
                          <Col xl={10} lg={24} style={{ margin: "auto" }}>
                            <div className="holder-signature-on-document">
                              <div ref={refBox} className="box-signature">
                                {bgSingature?.length === 0 && (
                                  <>
                                    <PrintDocument
                                      print={{
                                        ...(formData?.from?.spForeign || formData?.another?.spForeign),
                                        branchcode: formData?.another?._currentUser?.branchcode,
                                      }}
                                      lang={formData?.another?.spForeign?.certtype === 1 ? "en" : "fa"}
                                      value={handleGetCanvas}
                                      canvas={true}
                                    />
                                  </>
                                )}
                                <ReactSignatureCanvas
                                  penColor="blue"
                                  canvasProps={{
                                    id: "canvasDoc",
                                    width: "100%",
                                    height: "100%",
                                    className: "sigCanvas",
                                  }}
                                  clearOnResize={false}
                                  backgroundColor="transparent"
                                  onEnd={writeSignatureHandler}
                                />
                                <img src={bgSingature} alt="" width={"100%"} />
                              </div>
                              {hasErrorSign && <p style={{ color: "#ff4d4f" }}>لطفا فرم نمایش داده را امضا کنید</p>}
                              <div className="holder-button">
                                <Button onClick={clearHandler} className="btn-normal">
                                  پاک کردن
                                </Button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      <>
                        <div className="item-step">
                          <p>1- نسبت به چاپ سند اقدام فرمایید</p>
                          <Button
                            className="btn-normal btn-print"
                            type="default"
                            icon={<i className="icon-print"></i>}
                            onClick={() => {
                              window.print();
                              setIsDisabled(false);
                            }}
                          >
                            چاپ سند
                          </Button>
                        </div>
                      </>
                    )}
                    <div className="item-step" style={{ display: signature ? "none" : "block" }}>
                      <p>2- سند مهر و امضا شده را بارگذاری کنید.</p>
                      <Row gutter={20}>
                        <Col span={12} lg={15} md={20} sm={24} xs={24}>
                          <Form form={frmDocument} layout="vertical">
                            <Form.Item
                              name="photo"
                              rules={[
                                {
                                  required: true,
                                  message: t("validation.required"),
                                },
                              ]}
                              label="تصویر سند"
                            >
                              <>
                                <ResizeImage disabled={isDisabled} exportImage={handleGetImage} />
                              </>
                            </Form.Item>
                          </Form>
                        </Col>
                        {/* <Col span={12} style={{ margin: "auto 0" }}>
                          <div className="hold-text">
                            <ul style={{ display: "none" }}>
                              <li>بارگذاری کارت ملی جدید یا شناسنامه جدید یا کارت ملی قدیمی همراه با رسید کارت ملی جدید</li>
                              <li>فرمت ها و حجم و رزولوشن قابل قبول</li>
                              <li>توضیح در مورد مشخص بودن گوشه های تصویر مدارک</li>
                            </ul>
                          </div>
                        </Col> */}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              <div className="g-footer-format-page">
                <div className="holder-button">
                  <Button className="btn-normal btn-aptel" type="primary" onClick={handleSubmit} danger>
                    مرحله بعد
                  </Button>
                  <Button
                    className="btn-normal"
                    onClick={() => nav(_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Kit)}
                    type="default"
                  >
                    بازگشت
                  </Button>
                </div>
              </div>
            </div>
          </Content>
        </div>
      </SPFShopLayout>

      <Loading isOpen={isLoading} />
    </>
  );
};
export default SPFDocument;
